import { render, staticRenderFns } from "./selectAddressDialog.vue?vue&type=template&id=f3b7f8d0&scoped=true"
import script from "./selectAddressDialog.vue?vue&type=script&lang=js"
export * from "./selectAddressDialog.vue?vue&type=script&lang=js"
import style0 from "./selectAddressDialog.vue?vue&type=style&index=0&id=f3b7f8d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b7f8d0",
  null
  
)

export default component.exports